'use strict';

angular.module('atex.art').factory('ArtUserDataStore',
['$q', '$rootScope', 'ArtGenericStore', 'ContentService',

  function($q, $rootScope, ArtGenericStore, ContentService) {
    var isOnlineFunc = function() {
      return true;
    };

    var serverAdapter = {
      getById: function(userDataId) {
        var transferInfo = { id: userDataId, variant: 'onecms' };

        return ContentService.getContent(transferInfo).then(function(responseInfo) {
          return responseInfo.data;
        });
      }
    };

    var contentStoreAdapter = {
      getById: ArtGenericStore.getById.bind(ArtGenericStore),
      getAll: ArtGenericStore.getAll.bind(ArtGenericStore),
      put: ArtGenericStore.put.bind(ArtGenericStore),
      putAll: function(objectStoreName, userDatas) {
        var promises = [];

        userDatas.forEach(function(userData) {
          promises.push(ArtGenericStore.put(objectStoreName, userData));
        });

        return $q.all(promises);
      }
    };

    return atex.DelegatingStore(atex.act.AngularUtils.applyingQ($q, $rootScope), isOnlineFunc, serverAdapter, contentStoreAdapter, "userdata");
  }
]);
